import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import useSpecificSubjectContext from './context';
import { JumpToSection } from './navigator';
import useToggleContext, { ToggleContextProvider } from '~/components/toggle/toggle-context';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import './subject-intro.scss';
function IntroContent({ subjectName }) {
    var _a;
    const introHtml = (_a = useSpecificSubjectContext().pageDescription) !== null && _a !== void 0 ? _a : '';
    const { isOpen } = useToggleContext();
    return (React.createElement("div", { className: cn('content', { open: isOpen }) },
        React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "subject.introText", defaultMessage: "Open textbooks" })),
        React.createElement("h1", null, subjectName),
        React.createElement(RawHTML, { className: "paragraph-html", html: introHtml }),
        React.createElement(JumpToSection, { subjectName: subjectName })));
}
export default function SubjectIntro({ subjectName }) {
    return (React.createElement("section", { className: "subject-intro" },
        React.createElement(ToggleContextProvider, null,
            React.createElement(IntroContent, { subjectName: subjectName }))));
}
